module.exports = __webpack_public_path__ + "5a74e9ed7c406c0b5bf9862048f6a395.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/modelo_planilha_cte.xlsx
// module id = ./src/assets/downloads/modelo_planilha_cte.xlsx
// module chunks = 1